import type { FeatureManifest } from '../registry.js';

/** Inbox deliveries (SO-01.3 restock delivered, gifts, league rewards) with OVL-09 on the next session. */
export default {
  id: 'inbox',
  online: true,
  provides: ['inbox'],
  entry: { order: 5, icon: 'mail', label: 'rail.inbox', testId: 'rail-inbox', open: 'inbox', badge: (a) => a.services.store.state.prompts.inboxUnread || null },
  mapOrder: 10,
  mapDue: (a) => a.services.sync.status !== 'offline' && !a.session.checked.has('inbox'),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
